
<template>
  <v-app>
    <v-container>
		<v-row>
		  <v-col cols="12" md="6" lg="4">
			<img :src="`https://nmgyyf.qzkj.vip/logo.png`" alt="Logo" class="responsive-img" />
		  </v-col>
		</v-row>
      <v-form ref="form" v-model="valid" lazy-validation class="large-font">

        <!-- Name -->
        <v-text-field
          v-model="name"
          :rules="nameRules"
          required		 
        >
          <template v-slot:label>
            <span>姓名 <span class='required-field'>*</span></span>
          </template>		  
        </v-text-field>		

        <!-- ID Card Number -->
        <v-text-field
          v-model="idCardNumber"
          :rules="idCardNumberRules"
          label="身份证号码"
          required		  
        ></v-text-field>

        <!-- Gender -->
        <v-select
          v-model="gender"
          :items="genderItems"
          :rules="[v => !!v || '性别是必填项']"
          label="性别"
          required		  
        ></v-select>

        <!-- Age -->
        <v-text-field
          v-model="age"
          :rules="ageRules"
          label="年龄"
          required		  
        ></v-text-field>
		
		<v-row>
		  <v-col cols="12" sm="6" md="4">
		    <v-select
		      :items="provinceItems"
		      item-text="text"
		      item-value="value"
		      label="省份"
		      v-model="province"
		      @change="onProvinceChange"
		      required
		    ></v-select>
		  </v-col>
		  <v-col cols="12" sm="6" md="4">
		    <v-select
		      :items="cityItems"
		      item-text="text"
		      item-value="value"
		      label="城市"
		      v-model="city"
		      @change="onCityChange"
		      required
		    ></v-select>
		  </v-col>
		  <v-col cols="12" sm="6" md="4">
				<v-select
				  :items="districtItems"
				  item-text="text"
				  item-value="value"
				  label="区域"
				  v-model="district"
				  required
				></v-select>		
		  </v-col>
		</v-row>		
		
		<!-- detailedAddress -->
		<v-text-field
		  v-model="detailedAddress"
		  label="详细地址"
		  :rules="[v => !!v || '详细地址是必填项']"
		  required
		></v-text-field>		

        <!-- Occupation -->
        <v-select
          v-model="occupation"
          :items="occupationItems"
          :rules="[v => !!v || '职业是必填项']"
          label="职业"
          required
        ></v-select>	
				
		<!-- 其他职业备注 -->
		<v-text-field
		  v-if="isOtherProfession"
		  v-model="otherProfession"
		  label="职业备注"
		  hint="请填写其他职业名称"
		  class="custom-hint"    
		  :required="isOtherProfession"
		></v-text-field>	

        <!-- Mobile Number -->
        <v-text-field
          v-model="mobile"
          :rules="mobileRules"
          label="手机号码"
          required
        ></v-text-field>

        <!-- Ethnicity -->
        <v-select
          v-model="ethnicity"
          :items="ethnicityItems"
          :rules="[v => !!v || '民族是必填项']"
          label="民族"
          required
        ></v-select>			

        <!-- Medical History -->
        <v-textarea
          v-model="medicalHistory"
          :rules="medicalHistoryRules"
          label="现病史"
		  hint="请详细描述你的病史，包括疾病的名称、发病时间等。"
		  class="custom-hint"
          required
        ></v-textarea>

        <!-- Smoking History -->
        <v-select
		  v-if="isLargerThan15"
          v-model="smokingHistory"
          :items="yesNoOptions"
          :rules="[v => !!v || '请选择吸烟史']"
          label="吸烟史"
          :required="isLargerThan15"
        ></v-select>

        <!-- Drinking History -->
        <v-select
		  v-if="isLargerThan15"
          v-model="drinkingHistory"
          :items="yesNoOptions"
          :rules="[v => !!v || '请选择饮酒史']"
          label="饮酒史"
          :required="isLargerThan15"
        ></v-select>

        <!-- Harmful Substance Contact History -->
        <v-select
		  v-if="isLargerThan15"
          v-model="harmfulSubstanceContact"
          :items="yesNoOptions"
          :rules="[v => !!v || '请选择有害物质接触史']"
          label="有害物质接触史"
          :required="isLargerThan15"
        ></v-select>

        <!-- Medication History -->
        <v-select
          v-model="medicationHistory"
          :items="yesNoOptions"
          :rules="[v => !!v || '请选择药物过敏史']"
          label="药物过敏史"
          required
        ></v-select>

        <!-- Marital Status -->
        <v-select
		  v-if="isLargerThan15"
          v-model="maritalStatus"
          :items="maritalStatusOptions"
          :rules="[v => !!v || '请选择婚姻情况']"
          label="婚姻情况"
          :required="isLargerThan15"
        ></v-select>

        <!-- Childbearing Status -->
        <v-select
		  v-if="isFemale && isLargerThan15"
          v-model="childbearingStatus"
          :items="childbearingStatusOptions"
          :rules="[v => !!v || '请选择生育情况']"
          label="生育情况"
          :required="isFemale && isLargerThan15"
        ></v-select>

        <!-- Number of Pregnancies -->       
        <v-select
		  v-if="isFemale && isLargerThan15"
          v-model="numberOfPregnancies"
          :items="numberOfPregnanciesItems"
          :rules="[v => !!v || '怀孕次数是必填项']"
          label="怀孕次数"
          :required="isFemale && isLargerThan15"
        ></v-select>	

        <!-- Number of Births -->
        <v-select
		  v-if="isFemale && isLargerThan15"
          v-model="numberOfBirths"
          :items="numberOfBirthsItems"
          :rules="[v => !!v || '生育次数是必填项']"
          label="生育次数"
          :required="isFemale && isLargerThan15"
        ></v-select>	
		
        <!-- torch_sx -->
        <v-select
		  v-if="isFemale && isLargerThan15"
          v-model="torch_sx"
          :items="normalAbnormalOptions"
          :rules="[v => !!v || '请选择TORCH四项情况']"
          label="TORCH四项"
          :required="isFemale && isLargerThan15"
        ></v-select>

        <!-- szjssp -->       
        <v-select
		  v-if="isFemale && isLargerThan15"
          v-model="szjssp"
          :items="normalAbnormalOptions"
          :rules="[v => !!v || '生殖激素水平是必填项']"
          label="生殖激素水平"
          required="isFemale && isLargerThan15"
        ></v-select>	

        <!-- Number of Births -->
        <v-select
		  v-if="isFemale && isLargerThan15"
          v-model="fbkt"
          :items="fbktItems"
          :rules="[v => !!v || '封闭抗体是必填项']"
          label="封闭抗体"
          :required="isFemale && isLargerThan15"
        ></v-select>	
				
        <!-- xuexing -->       
        <v-select
          v-model="xuexing"
          :items="xuexingOptions"
          :rules="[v => !!v || '血型是必填项']"
          label="血型"
          required
        ></v-select>	
						
        <v-select
		  v-if="isMale && isLargerThan15"
          v-model="jycg_huoli"
          :items="normalAbnormalOptions"
          :rules="[v => !!v || '精液常规-活力是必填项']"
          label="精液常规-活力"
          :required="isMale && isLargerThan15"
        ></v-select>
								
        <v-select
		  v-if="isMale && isLargerThan15"
          v-model="jycg_huolv"
          :items="normalAbnormalOptions"
          :rules="[v => !!v || '精液常规-活率是必填项']"
          label="精液常规-活率"
          :required="isMale && isLargerThan15"
        ></v-select>		
								
        <!-- 辅助检查 -->       
        <v-select
          v-model="fzjc"
          :items="fzjcOptions"
          :rules="[v => !!v || '辅助检查是必填项']"
          label="辅助检查"
          required
        ></v-select>
										
        <!-- 临床诊断 -->       
        <v-select
          v-model="lczd"
          :items="lczdOptions"
          :rules="[v => !!v || '临床诊断是必填项']"
          label="临床诊断"
          required
        ></v-select>	
											
        <!-- 其他说明 -->
        <v-textarea
          v-model="other_info"
          label="其他说明"
		  hint=""
		  class="custom-hint"          
        ></v-textarea>	
												
		<div>
		    <v-menu v-model="menu" :close-on-content-click="false">
		      <template v-slot:activator="{ on, attrs }">
		        <v-text-field v-model="appointment_date" label="请选择预约日期" :rules="[v => !!v || '预约日期是必填项']" readonly v-bind="attrs" v-on="on" required></v-text-field>
		      </template>
		      <v-date-picker v-model="appointment_date" @input="menu = false"></v-date-picker>
		    </v-menu>
		  </div>

		<!-- Submit Button -->
		<v-btn :disabled="!valid" color="success" class="mr-4" @click="submit">
		提交
		</v-btn>

		<v-btn color="error" class="mr-4" @click="reset">
		重置
		</v-btn>
      </v-form>
		<div>
		  <v-card>
			<v-card-title class="justify-center">
			  染色体检查注意事项
			</v-card-title>
			<v-card-text class="text-left">
			  <pre class="pre-text">{{ readonlyField }}</pre>
			</v-card-text>
		  </v-card>
		</div>
    </v-container>
  </v-app>
</template>

<script>
import areaData from "china-area-data";
import { VApp, VDatePicker } from 'vuetify/lib';
import zhHans from 'vuetify/lib/locale/zh-Hans'; // 引入中文简体本地化

import {
	fetchPost
} from "@/utils/request"
	
export default {
	components: {
		VApp,
		VDatePicker
	  },
  data: () => ({
		valid: true,
		name: '',
		nameRules: [v => !!v || '姓名是必填项'],
		idCardNumber: '',
		idCardNumberRules: [v => !!v || '身份证号码是必填项'],
		gender: null,
		genderItems: ['男', '女'],
		age: '',
		ageRules: [v => !!v || '年龄是必填项'],
		occupation: null,
		// occupationItems: ['农林牧渔业劳动者', '工人劳动者','服务业人员','技术开发/工程师','老师/科研/医护人员','产品/运营/设计从业者','市场/销售/商务/行政/采购', '财务/会计/出纳/审计', '律师/法务','个体经营者/自由职业','企业管理者','党政机关/事业单位人员','全职家庭主妇/夫','学生','其他'],
		occupationItems: ['农民', '工人','工程师','教师','医护人员','公务员','警察','其他'],
		otherProfession: '',
		mobile: '',
		mobileRules: [v => !!v || '手机号码是必填项'],
		ethnicity: null,
		ethnicityItems: ['汉族','蒙古族', '回族', '满族', '其他民族'],
		medicalHistory: '',
		medicalHistoryRules: [v => !!v || '现病史是必填项'],
		smokingHistory: null,
		drinkingHistory: null,
		harmfulSubstanceContact: null,
		medicationHistory: null,
		maritalStatus: '未婚',
		childbearingStatus: null,
		numberOfPregnancies: null,
		numberOfPregnanciesItems: ['没有怀孕历史', '怀孕过1次','怀孕过2次', '怀孕过3次', '怀孕过3次以上'],
		numberOfBirths: null,
		numberOfBirthsItems: ['没有生育过', '生育过1次','生育过2次', '生育过3次', '生育过3次以上'],
		yesNoOptions: ['是', '否'],
		maritalStatusOptions: ['已婚', '未婚', '再婚'],
		childbearingStatusOptions: ['已育', '未育'],
		genderMap: {
			'男': 'Male',
			'女': 'Female'
		},
		/* occupationMap: {
			'农林牧渔业劳动者': 'nlmyyldz', 
			'工人劳动者': 'grldz',
			'服务业人员': 'fwyry',
			'技术开发/工程师': 'jg',
			'老师/科研/医护人员': 'lky',
			'产品/运营/设计从业者': 'cys',
			'市场/销售/商务/行政/采购': 'sxsxc',
			'财务/会计/出纳/审计': 'ckcs',
			'律师/法务': 'lf',
			'个体经营者/自由职业': 'gz',
			'企业管理者': 'qyglz',
			'党政机关/事业单位人员': 'ds',
			'全职家庭主妇/夫': 'qzjtzf',
			'学生': 'xs',
			'其他': 'other'
			}, */
		occupationMap: {
			'农民': 'nlmyyldz', 
			'工人': 'grldz',			
			'工程师': 'jg',
			'教师': 'lky',		
			'医护人员': 'yhry',
			'公务员': 'ds',			
			'警察': 'jingcha',
			'其他': 'other'
			},		
		isOtherProfession: false,
		ethnicityMap: {
			'蒙古族': 'meng',
			'汉族': 'han',
			'回族': 'hui',
			'满族': 'man',
			'其他民族': 'other'
		},		
		yesNoOptionsMap: {
			'是': 'yes',
			'否': 'no'
		},
		maritalStatusMap: {
			'已婚': 'married',
			'未婚': 'single',
			'再婚': 'remarried'
		},		
		childbearingStatusMap: {
			'已育': 'fertile',
			'未育': 'infertile'
		},	
		numberOfPregnanciesMap: {
			'没有怀孕历史': 'zero',
			'怀孕过1次': 'one',
			'怀孕过2次': 'two',
			'怀孕过3次': 'three',
			'怀孕过3次以上': 'above3'
		},		
		numberOfBirthsMap: {
			'没有生育过': 'zero',
			'生育过1次': 'one',
			'生育过2次': 'two',
			'生育过3次': 'three',
			'生育过3次以上': 'above3'
		},		
		errors: [],
		requiredFields: {
			name: '姓名',
			idCardNumber: '身份证号码',
			gender: '性别',
			age: '年龄',
			province: '省份',
			city: '城市',
			district: "地区",
			detailedAddress: '详细住址',
			occupation: '职业',
			otherProfession: '职业备注',
			mobile: '手机号码',
			ethnicity: '民族',
			medicalHistory: '现病史',
			smokingHistory: '吸烟史',
			drinkingHistory: '饮酒史',
			harmfulSubstanceContact: '有害物质接触史',
			medicationHistory: '药物过敏史',
			maritalStatus: '婚姻情况',
			childbearingStatus: '生育情况',
			numberOfPregnancies: '怀孕次数',			
			numberOfBirths: '生育次数',
			detailedAddress: '详细住址',
			torch_sx: 'TORCH四项',  
			szjssp: '生殖激素水平',
			fbkt: '封闭抗体',
			xuexing: '血型',
			jycg_huoli: '精液常规-活力',  
			jycg_huolv: '精液常规-活率',
			fzjc: '辅助检查',
			lczd: '临床诊断',
			appointment_date: '预约日期',
		},
		readonlyField: '',  
		isFemale: false,
		isMale: false,
		isLargerThan15: true,
		province: "",
		city: "",
		district: "",
		provinceItems: [],
		cityItems: [],
		districtItems: [],
		detailedAddress: "",		
		torch_sx: null,  
		szjssp: null,
		fbkt: null,
		xuexing: null,
		jycg_huoli: null,  
		jycg_huolv: null,
		fzjc: null,
		lczd: null,
		other_info: "",
		normalAbnormalOptions: ['正常', '异常', '未查'],
		normalAbnormalMap: {
			'正常': 'normal',
			'异常': 'abnormal',
			'未查': 'not_examined',
		},		
		fbktItems: ['阳性', '阴性', '未查'],
		fbktMap: {
			'阳性': 'positive',
			'阴性': 'negative',
			'未查': 'not_examined',
		},	
	    xuexingOptions: ['A型', 'B型', 'AB型', 'O型', '未查'],
		xuexingMap: {
			'A型': 'typeA',
			'B型': 'typeB',
			'AB型': 'typeAB',
			'O型': 'typeO',
			'未查': 'not_examined',
		},	
		fzjcOptions: ['正常', '异常'],
		fzjclMap: {
			'正常': 'normal',
			'异常': 'abnormal',			
		},		
		lczdOptions: ['不孕不育', '习惯性流产', '稽留流产', '不良生育史', '原发性闭经', '继发性闭经', '21-三体','矮小症', '生长发育不良', '其他'],
		lczdMap: {
			'不孕不育': 'byby',
			'习惯性流产': 'xgxlc',
			'稽留流产': 'jllc',
			'不良生育史': 'blsys',
			'原发性闭经': 'yfxbj',
			'继发性闭经': 'jfxbj',
			'21-三体': 'santi21',
			'矮小症': 'axz',
			'生长发育不良': 'szfybl',
			'其他': 'others',		
		},
		menu: false,
		appointment_date: null,
    }),
	created() {
		this.$vuetify.lang.current = 'zh-Hans'; // 设置当前语言为中文简体
		this.$vuetify.lang.locales['zh-Hans'] = zhHans; // 将zhHans对象分配给'zh-Hans'键
		this.provinceItems = this.getProvinceItems();
		fetch('https://nmgyy.qzkj.vip/api/getreadonly')
		  .then(response => response.json())
		  .then(data => {
			this.readonlyField = data.readonly_field;
		  })
		  .catch(error => {
			console.error(error);
		  });
	},
	watch: {
	  gender(newVal) {
	    this.isFemale = newVal === '女';
		this.isMale = newVal === '男';
	  },
	  age(newVal) {
		  this.isLargerThan15 = newVal > 15;
	  },
	  occupation(newVal) {
		  console.log(newVal)
		  this.isOtherProfession = newVal === '其他';	  		
		  console.log(this.isOtherProfession)
	  },
	  isLargerThan15(newVal, oldVal) {
		if (newVal !== oldVal) {
		  if (newVal) {
			this.maritalStatus = null; // 当 isLargerThan15 = True 时
		  } else {			
			this.smokingHistory = null;
			this.drinkingHistory = null;
			this.harmfulSubstanceContact = null;
			this.maritalStatus = '未婚'; // 当 isLargerThan15 = False 时
			this.jycg_huoli = null;
			this.jycg_huolv = null;
			this.childbearingStatus = null;
			this.numberOfPregnancies = null;
			this.numberOfBirths = null;
			this.torch_sx = null;
			this.szjssp = null;
			this.fbkt = null;
		  }
		}
	  },
	  isOtherProfession(newVal, oldVal) {
	  		if (newVal !== oldVal) {
	  		  if (newVal) {	  			
	  		  } else {
	  			this.otherProfession = ''; // 当 isOtherProfession = False 时,清空	  			
	  		  }
	  		}
	  },
	},
  methods: {
	submit() {
		var data = {
			name: this.name,
			id_card_number: this.idCardNumber,
			gender: this.genderMap[this.gender],
			age: this.age,
			profession: this.occupationMap[this.occupation],
			otherProfession:this.otherProfession,
			phone_number: this.mobile,
			ethnicity: this.ethnicityMap[this.ethnicity],
			current_disease_history: this.medicalHistory,
			smoking_history: this.yesNoOptionsMap[this.smokingHistory],
			drinking_history: this.yesNoOptionsMap[this.drinkingHistory],
			harmful_substance_contact: this.yesNoOptionsMap[this.harmfulSubstanceContact],
			medication_history: this.yesNoOptionsMap[this.medicationHistory],
			marital_status: this.maritalStatusMap[this.maritalStatus],
			fertility_status: this.childbearingStatusMap[this.childbearingStatus],
			number_of_pregnancies: this.numberOfPregnanciesMap[this.numberOfPregnancies],
			number_of_births: this.numberOfBirthsMap[this.numberOfBirths],
			province: areaData['86'][this.province],
			city: areaData[this.province][this.city],
			district: areaData[this.city][this.district],
			detailed_address: this.detailedAddress, 
			torch_sx: this.normalAbnormalMap[this.torch_sx],  
			szjssp: this.normalAbnormalMap[this.szjssp],
			fbkt: this.fbktMap[this.fbkt],
			xuexing: this.xuexingMap[this.xuexing],
			jycg_huoli: this.normalAbnormalMap[this.jycg_huoli], 
			jycg_huolv: this.normalAbnormalMap[this.jycg_huolv],
			fzjc: this.fzjclMap[this.fzjc],
			lczd: this.lczdMap[this.lczd],
			other_info: this.other_info,
			appointment_date: this.appointment_date,
		}
		this.errors = [];
		
		for (let field in this.requiredFields) {
		    // If the gender is '男' and the field is one of the female-specific fields, skip the check
			if (!this.isLargerThan15 && ['smokingHistory','drinkingHistory','harmfulSubstanceContact','maritalStatus','childbearingStatus', 'numberOfPregnancies', 'numberOfBirths','torch_sx', 'szjssp', 'fbkt','jycg_huoli', 'jycg_huolv'].includes(field)) {
			    continue;
			}
		    if (this.gender === '男' && ['childbearingStatus', 'numberOfPregnancies', 'numberOfBirths','torch_sx', 'szjssp', 'fbkt'].includes(field)) {
		        continue;
		    }
			if (this.gender === '女' && ['jycg_huoli', 'jycg_huolv'].includes(field)) {
			    continue;
			}
			if (this.occupation !== '其他' && ['otherProfession'].includes(field)) {
			    continue;
			}
		    if (!this[field]) {
		        this.errors.push(this.requiredFields[field]);
		    }
		}

	
		if (this.errors.length > 0) {
			alert("以下字段是必填项: " + this.errors.join(", "));
			return;
		}
		console.log(data)
		fetchPost('/api/submitform', data).then(response => {
			console.log(response);  // 打印 response
			if (response.data.success) {
				alert('提交成功，请不要重复提交！');		
			} else {						
				alert('提交失败，请检查后重新提交！');
			}
		})
    },
	convertAreaData(data) {
	  return Object.keys(data).map((key) => ({
	    value: key,
	    text: data[key],
	  }));
	},
	getProvinceItems() {
	  let provinces = this.convertAreaData(areaData["86"]);
	  const innerMongoliaIndex = provinces.findIndex(
	    (item) => item.text === "内蒙古自治区"
	  );
	  if (innerMongoliaIndex !== -1) {
	    const innerMongolia = provinces.splice(innerMongoliaIndex, 1);
	    provinces.unshift(...innerMongolia);
	  }
	  return provinces;
	},
	onProvinceChange() {
	  console.log(areaData['86'][this.province]);
	  this.cityItems = this.convertAreaData(areaData[this.province]);
	  this.city = "";
	  this.district = "";
	  this.districtItems = [];
	},
	onCityChange() {
	  console.log(areaData[this.province][this.city]);
	  this.districtItems = this.convertAreaData(areaData[this.city]);
	  this.district = "";
	},
	reset() {
	  this.$refs.form.reset();
	  
	  this.childbearingStatus = null;
	  this.numberOfPregnancies = null;  
	  this.numberOfBirths = null; 
	  this.torch_sx = null; 
	  this.szjssp = null; 
	  this.fbkt = null; 
	  this.jycg_huoli = null;
	  this.jycg_huolv = null;
	},
  },
}
</script>

<style scoped>
.large-font .v-text-field {
  font-size: 20px;
}

.v-label {
    font-size: 20px; /* 或你想要的其他大小 */
}

.required-field {
  color: red;
  font-size: 20px;
}

.v-image {
  max-width: 100%;
}

.responsive-img {
  max-width: 100%;
  height: auto;
}

.custom-hint .v-messages__message {
    color: red;
}

pre {
  word-wrap: break-word;
  white-space: pre-wrap;
}

.pre-text {
  font-size: 20px; /* 设置字体大小 */
/*  font-weight: bold; /* 设置字体粗体 */ 
}
</style>
